"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var hydrogen_react_1 = require("@shopify/hydrogen-react");
var CartContext_1 = require("./CartContext");
var cart_1 = require("../../utils/cart");
var ga_1 = require("../../utils/ga");
var CartItem = function (_a) {
    var _b;
    var item = _a.item;
    console.log('item', item);
    var _c = (0, hooks_1.useContext)(CartContext_1.default), allProducts = _c.allProducts, renderCart = _c.renderCart;
    var itemAsProduct = allProducts.find(function (product) { return Number(product.id.split('/')[4]) === item.product_id; });
    if (!itemAsProduct) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    var handleUpdateQuantity = function (itemId, qty, actionType) { return __awaiter(void 0, void 0, void 0, function () {
        var cartData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, (0, cart_1.updateItemQuantity)(itemId, qty)];
                case 1:
                    cartData = _a.sent();
                    return [4 /*yield*/, renderCart(cartData)];
                case 2:
                    _a.sent();
                    if (window.sessionStorage.getItem('flashSaleAbV2') == 'true') {
                        dispatchEvent(new Event('appliedOffer'));
                    }
                    if (actionType === 'increment') {
                        (0, ga_1.sendEventAddToCart)(itemAsProduct, itemAsProduct.variants.nodes[itemAsProduct.variants.nodes.length - 1], ga_1.GaMethodValue.cartUpdateQuantity);
                        (0, ga_1.sendEvent)("ce_cart_item_increment_".concat((0, cart_1.isSubscriptionCartItem)(item) ? 'subscription' : 'oneTime'));
                    }
                    else {
                        (0, ga_1.sendEventRemoveFromCart)(itemAsProduct, itemAsProduct.variants.nodes[itemAsProduct.variants.nodes.length - 1], ga_1.GaMethodValue.cartUpdateQuantity);
                        (0, ga_1.sendEvent)("ce_cart_item_decrement_".concat((0, cart_1.isSubscriptionCartItem)(item) ? 'subscription' : 'oneTime'));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Error updating item quantity:', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var featured_image = item.featured_image, image = item.image, quantity = item.quantity, title = item.title, variant_title = item.variant_title, handle = item.handle, final_line_price = item.final_line_price;
    var strikethroughPrice = itemAsProduct.variants.nodes[0].compareAtPrice
        ? Number((_b = itemAsProduct.variants.nodes[0].compareAtPrice) === null || _b === void 0 ? void 0 : _b.amount) * quantity
        : Number(itemAsProduct.variants.nodes[0].price.amount) * quantity;
    var price = 
    // Convert final_line_price from cents to dollars, fallback to original price calculation if not available
    final_line_price
        ? final_line_price / 100.0
        : Number(itemAsProduct.variants.nodes[0].price.amount) * quantity;
    if (item.variant_title) {
        var itemVariant = itemAsProduct.variants.nodes.find(function (variant) { return Number(variant.id.split('/')[4]) === item.variant_id; });
        if (itemVariant) {
            if (itemVariant.compareAtPrice) {
                strikethroughPrice = parseFloat(itemVariant.compareAtPrice.amount) * quantity;
            }
            if (!strikethroughPrice) {
                strikethroughPrice = parseFloat(itemVariant.price.amount) * quantity;
            }
        }
    }
    var itemTitle = variant_title ? variant_title : title;
    var decodeHtml = function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        return doc.documentElement.textContent || '';
    };
    if (itemTitle.includes('&#39;')) {
        itemTitle = decodeHtml(itemTitle);
    }
    var targetUrl = "https://opositiv.com/products/".concat(handle);
    var itemDescription;
    if ((0, cart_1.isSubscriptionCartItem)(item)) {
        var shipInterval = item.selling_plan_allocation.selling_plan.name.split(' ')[2];
        if (shipInterval === '1') {
            itemDescription = 'Ships Monthly';
        }
        else {
            itemDescription = "Ships Every ".concat(shipInterval, " Months");
        }
    }
    else if ((0, cart_1.isUpsellItem)(item)) {
        itemDescription = 'Exclusive Offer, One Time';
    }
    else {
        itemDescription = 'One Time Purchase';
    }
    return ((0, preact_1.h)("div", { class: "cart-section__cart-item" },
        window.clickableImageAb ? ((0, preact_1.h)("a", { href: "".concat(targetUrl), class: "cart-href-ab" },
            (0, preact_1.h)("img", { alt: featured_image.alt, class: "cart-section__cart-item-image", src: image ||
                    'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_300x300.gif', width: 300, height: 300 }))) : ((0, preact_1.h)("img", { alt: featured_image.alt, class: "cart-section__cart-item-image", src: image ||
                'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_300x300.gif', width: 300, height: 300 })),
        (0, preact_1.h)("div", { class: "cart-section__cart-item-product-details" },
            (0, preact_1.h)("div", { class: "cart-section__cart-item-info" },
                window.clickableImageAb ? ((0, preact_1.h)("a", { href: "".concat(targetUrl), class: "cart-href-ab" },
                    (0, preact_1.h)("p", { class: "cart-section__cart-item-info-title" }, itemTitle))) : ((0, preact_1.h)("p", { class: "cart-section__cart-item-info-title" }, itemTitle)),
                (0, preact_1.h)("p", { class: "cart-section__cart-item-info-description" }, itemDescription)),
            (0, preact_1.h)("div", { class: "cart-section__cart-item-update" },
                (0, preact_1.h)("div", { class: "cart-section__cart-item-update-quantity" },
                    (0, preact_1.h)("button", { class: "cart-section__cart-item-update-quantity-decrement", onClick: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, handleUpdateQuantity(item.key, quantity - 1, 'decrement')];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        }); }); }, type: "button" }, "\u2212"),
                    (0, preact_1.h)("p", { class: "cart-section__cart-item-update-quantity-amount" }, quantity),
                    (0, preact_1.h)("button", { class: "cart-section__cart-item-update-quantity-increment", onClick: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, handleUpdateQuantity(item.key, quantity + 1, 'increment')];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        }); }); }, type: "button" }, "+")),
                (0, preact_1.h)("p", { class: "cart-section__cart-item-update-price" },
                    strikethroughPrice !== price && ((0, preact_1.h)("s", { class: "cart-section__cart-item-update-price--strikethrough" }, (0, hydrogen_react_1.useMoney)({ amount: strikethroughPrice.toFixed(2), currencyCode: 'USD' })
                        .withoutTrailingZeros)),
                    "\u00A0",
                    (0, hydrogen_react_1.useMoney)({ amount: price.toFixed(2), currencyCode: 'USD' }).localizedString)))));
};
exports.default = CartItem;
